export const WEB_SOCKET_DATA = "WEB_SOCKET_DATA";

export const setWebSocketData = (data) => ({
  type: WEB_SOCKET_DATA,
  payload: data,
});



export const ORDER_DATA = "ORDER_DATA";

/* export const setOrderData = (data) => ({
  type: ORDER_DATA,
  payload: data,
}); */

export const setOrderData = (data) => {
 
  //logger.log("Order_Data:", data);


  return {
  type: ORDER_DATA,
  payload: data,
  };
};
